export default {
  organisation: null,
  organisation_user: null,

  dpr_reports: [],
  unread_notifications: null,
  user_permissions: []
}